import styled from 'styled-components'

export const tabAssociacaoStyles = {
  Container: styled.div`
    margin: 16px;
  `
}
